"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _classnames = _interopRequireDefault(require("classnames"));
var _compose = _interopRequireDefault(require("ramda/src/compose"));
var _mergeLeft = _interopRequireDefault(require("ramda/src/mergeLeft"));
var _styles = require("@material-ui/styles");
var _AvatarV = _interopRequireDefault(require("../AvatarV2/AvatarV2"));
var _Clamp = _interopRequireDefault(require("../../Clamp/Clamp"));
var _Grid = _interopRequireDefault(require("../../Grid/Grid"));
var _Text = require("../../Text/Text");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    container: {
      position: 'relative',
      padding: '1rem',
      height: '15rem',
      border: "1px solid ".concat(theme.colors.lightGrey),
      borderRadius: theme.variables.borderRadiusSmall,
      boxShadow: "0px 1px 2px 0px ".concat(theme.colors.lightGreyAlpha),
      textAlign: 'left'
    },
    avatar: {
      '&, &:active, &:focus, &:hover': {
        marginBottom: '1rem',
        padding: 0,
        width: '2.5rem',
        height: '2.5rem',
        borderRadius: 0
      }
    },
    displayName: {
      display: 'block',
      marginBottom: '0.5rem',
      width: '100%',
      fontWeight: '700'
    },
    description: {
      display: 'block',
      marginBottom: '0.5rem',
      width: '100%',
      color: theme.colors.pebbleGrey
    },
    footer: {
      overflow: 'hidden',
      position: 'absolute',
      right: 0,
      bottom: 0,
      left: 0,
      height: '2rem',
      padding: '0 1rem',
      backgroundColor: theme.colors.blueGrey,
      color: theme.colors.pebbleGrey,
      lineHeight: '2rem'
    },
    footerContainer: {
      padding: '1rem 1rem 2.5rem'
    }
  };
});
/*:: type MenuType = React.Element<any>;*/
/*:: type Props = {|
  backgroundColor?: string,
  children?: React.Node,
  className?: string,
  description?: string | React.Element<typeof FormattedMessage>,
  displayName: string | React.Element<typeof FormattedMessage>,
  favorite?: React.Node,
  footer?: React.Node,
  isFavorite?: boolean,
  menu?: MenuType,
  src: string
|};*/
// typeof Menu
var Card = function Card(_ref /*:: */) {
  var backgroundColor = _ref /*:: */.backgroundColor,
    children = _ref /*:: */.children,
    className = _ref /*:: */.className,
    description = _ref /*:: */.description,
    displayName = _ref /*:: */.displayName,
    favorite = _ref /*:: */.favorite,
    footer = _ref /*:: */.footer,
    menu = _ref /*:: */.menu,
    src = _ref /*:: */.src;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(_Grid.default, {
    className: (0, _classnames.default)(classes.container, (0, _defineProperty2.default)({}, classes.footerContainer, footer), className),
    container: true
  }, /*#__PURE__*/React.createElement(_Grid.default, {
    container: true,
    direction: "column",
    item: true,
    xs: true,
    zeroMinWidth: true
  }, /*#__PURE__*/React.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/React.createElement(_Grid.default, {
    item: true,
    xs: true
  }, /*#__PURE__*/React.createElement(_AvatarV.default, {
    appearance: "square",
    borderColor: "transparent",
    className: classes.avatar,
    component: function component(_ref2) {
      var className = _ref2.className,
        children = _ref2.children;
      return /*#__PURE__*/React.createElement("span", {
        className: className
      }, children);
    },
    size: "large",
    src: src,
    theme: function theme(current, props) {
      return (0, _compose.default)((0, _mergeLeft.default)({
        backgroundColor: backgroundColor || 'transparent',
        borderRadius: 0,
        dimensions: {
          width: 'auto',
          height: 'auto'
        }
      }), current)(props);
    }
  })), (favorite || menu) && /*#__PURE__*/React.createElement(_Grid.default, {
    container: true,
    item: true,
    justify: "flex-end",
    xs: true
  }, favorite && /*#__PURE__*/React.createElement(_Grid.default, {
    item: true
  }, favorite), menu && /*#__PURE__*/React.createElement(_Grid.default, {
    item: true
  }, menu))), /*#__PURE__*/React.createElement(_Text.SmallText, {
    className: classes.displayName
  }, /*#__PURE__*/React.createElement(_Clamp.default, {
    clamp: 2
  }, displayName)), description && /*#__PURE__*/React.createElement(_Text.ExtraSmallText, {
    className: classes.description
  }, /*#__PURE__*/React.createElement(_Clamp.default, {
    clamp: 4
  }, description)), children, footer && /*#__PURE__*/React.createElement(_Text.ExtraSmallText, {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(_Clamp.default, {
    clamp: 1
  }, footer))));
};
Card.displayName = 'Card';
var _default = exports.default = Card;
//# sourceMappingURL=Card.js.map